import React, { FC } from 'react';

import { EvSkeleton } from '@evinced-private/ui-common';

import './ChartSkeleton.scss';

interface ChartSkeletonProps {
	titleWidth?: string;
	legendWidth?: string;
	contentHeight?: string;
	animationSpeed?: number;
}

export const ChartSkeleton: FC<ChartSkeletonProps> = ({
	titleWidth = '150px',
	legendWidth = '200px',
	contentHeight = '410px',
	animationSpeed
}) => {
	return (
		<div className="chart-skeleton">
			{/* Top row: Title and Legend */}
			<div className="skeleton-header">
				<EvSkeleton height="24px" width={titleWidth} animationSpeed={animationSpeed} />
				<EvSkeleton height="24px" width={legendWidth} animationSpeed={animationSpeed} />
			</div>

			{/* Chart content */}
			<div className="skeleton-chart-content">
				<EvSkeleton height={contentHeight} width="100%" animationSpeed={animationSpeed} />
			</div>
		</div>
	);
};
